// extracted by mini-css-extract-plugin
export var centeredcta = "centered-call-to-action-module--centeredcta--205a3";